import { SHARED_FILTERS } from './send-mail-stepper-shared-filters';

export const SEND_MAIL_STEPPER_EDIT_FILTERS = {
  path: '/mailing/stepper/:id',
  filters: SHARED_FILTERS
}; 